module.exports = __webpack_public_path__ + "static/media/supervisor.8f7824b3.svg";